import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import bestpractices from "../../../../assets/videos/blogs/pp21/bestpractices.mp4";
import * as React from 'react';
export default {
  PolypaneIntro,
  bestpractices,
  React
};